import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Tabs,
  Row,
  Col,
  message,
  Checkbox,
} from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import fetchData from "../../services/requester";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadImg from "../upload-img";

const DealAdd = (props) => {
  const [data, setData] = useState("");
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  const getData = () => {
    const { dealId } = props;
    let reqURL = "deals/detail/" + dealId;
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        if (data) {
          setData(data[0] || "");
          setDefaultData(data[0] || "");
          setLoading(false);
        }
      },
      "GET"
    );
  };

  const setDefaultData = (data) => {
    form.setFieldsValue({
      title: data?.title,
      type: data?.type,
      location: data?.location,
      imageURL: data?.imageURL,
      price: data?.price,
      shortDescription: data?.shortDescription,
      summaryDescription: data?.summaryDescription,
      overview: data?.overview,
      itinerary: data?.itinerary,
      inclusions: data?.inclusions,
      exclusions: data?.exclusions,
      terms: data?.terms,
      showOnHome: data?.showOnHome,
    });
  };

  const onFinish = (values) => {
    setLoading(true);
    let reqURL = "deals/" + (props.isEditMode ? "update" : "add");
    let reqOBJ = values;

    if (props?.isEditMode) {
      reqOBJ.dealId = props?.dealId;
      reqOBJ.overview = values?.overview || data?.overview;
      reqOBJ.itinerary = values?.itinerary || data?.itinerary;
      reqOBJ.inclusions = values?.inclusions || data?.inclusions;
      reqOBJ.exclusions = values?.exclusions || data?.exclusions;
      reqOBJ.terms = values?.terms || data?.terms;
    }

    fetchData(reqURL, reqOBJ, (data) => {
      setLoading(false);
      data?.success
        ? props.handleAdd()
        : message.error("Oops! Something went wrong.");
    });
  };

  const handleUpload = (imageURL) => {
    form.setFieldsValue({ imageURL });
  };

  const layout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 18,
    },
  };
  const col1 = {
    labelCol: {
      span: 10,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const col2 = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 14,
    },
  };
  const col3 = {
    wrapperCol: {
      span: 24,
    },
  };

  useEffect(() => {
    props?.isEditMode && getData();
  }, []);

  return (
    <React.Fragment>
      <Form
        name="deal-add"
        className="deal-add"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={{ type: "hotdeal", showOnHome: true }}
        {...layout}
      >
        <Row>
          <Col xs={24} xl={12}>
            <Form.Item label="Type" name="type" {...col1}>
              <Select placeholder="Select Deal Type">
                <Select.Option value="hotdeal">Popular Deal</Select.Option>
                <Select.Option value="package">Package</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Title" name="title">
          <Input placeholder="Enter Title" />
        </Form.Item>

        <Row>
          <Col xs={24} xl={12}>
            <Form.Item label="Location" name="location" {...col1}>
              <Input placeholder="Enter Location" />
            </Form.Item>
          </Col>
          <Col xs={24} xl={12}>
            <Form.Item label="Price" name="price" {...col2}>
              <Input placeholder="Enter Price" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} xl={24}>
            <Form.Item label="Image" name="imageURL">
              <UploadImg
                path="uploadfile"
                type="file-input"
                handleUpload={handleUpload}
                image={data?.imageURL}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} xl={19} offset="4">
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="Description" key="1">
                <Form.Item
                  name="shortDescription"
                  getValueFromEvent={(event, editor) => {
                    const data = editor.getData();
                    return data;
                  }}
                  {...col3}
                >
                  <CKEditor
                    data={data?.shortDescription || ""}
                    editor={ClassicEditor}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "280px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Overview" key="2">
                <Form.Item
                  name="overview"
                  getValueFromEvent={(event, editor) => {
                    const data = editor.getData();
                    return data;
                  }}
                  {...col3}
                >
                  <CKEditor
                    data={data?.overview || ""}
                    editor={ClassicEditor}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "280px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Itinerary" key="3">
                <Form.Item
                  name="itinerary"
                  getValueFromEvent={(event, editor) => {
                    const data = editor.getData();
                    return data;
                  }}
                  {...col3}
                >
                  <CKEditor
                    data={data?.itinerary || ""}
                    editor={ClassicEditor}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "280px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Inclusions" key="4">
                <Form.Item
                  name="inclusions"
                  getValueFromEvent={(event, editor) => {
                    const data = editor.getData();
                    return data;
                  }}
                  {...col3}
                >
                  <CKEditor
                    data={data?.inclusions || ""}
                    editor={ClassicEditor}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "280px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Exclusions" key="5">
                <Form.Item
                  name="exclusions"
                  getValueFromEvent={(event, editor) => {
                    const data = editor.getData();
                    return data;
                  }}
                  {...col3}
                >
                  <CKEditor
                    data={data?.exclusions || ""}
                    editor={ClassicEditor}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "280px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Terms" key="6">
                <Form.Item
                  name="terms"
                  getValueFromEvent={(event, editor) => {
                    const data = editor.getData();
                    return data;
                  }}
                  {...col3}
                >
                  <CKEditor
                    data={data?.terms || ""}
                    editor={ClassicEditor}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "280px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                </Form.Item>
              </Tabs.TabPane>
            </Tabs>
          </Col>
        </Row>

        <Row>
          <Col xs={4} xl={4}></Col>
          <Col xs={20} xl={20}>
            <Form.Item name="showOnHome" valuePropName="checked">
              <Checkbox>Show on Home</Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          wrapperCol={{
            offset: 4,
            span: 16,
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            icon={!props?.isEditMode ? <PlusOutlined /> : <EditOutlined />}
          >
            {(!props?.isEditMode ? "Add " : "Update") + "Deal"}
          </Button>
        </Form.Item>
      </Form>
    </React.Fragment>
  );
};

export default DealAdd;
